<template>
  <v-container>
    <v-card>
      <v-form class="pa-3" v-model="isFormValid">
        <v-text-field
          v-model="clientData.client_name"
          label="Company"
          id="company-company"
          filled
          @input="changed = true"
          required
        ></v-text-field>
        <v-text-field
          v-model="clientData.address.address_1"
          label="Address"
          id="company-address"
          filled
          required
          @input="changed = true"
        ></v-text-field>
        <v-select
          v-model="clientData.address.state"
          label="State"
          id="company-state"
          @input="changed = true"
          filled
          :items="_getStates"
        ></v-select>
        <v-text-field
          v-model="clientData.address.country"
          label="Country"
          id="company-country"
          filled
          @input="changed = true"
          required
        ></v-text-field>
        <v-text-field
          v-model="clientData.address.zip"
          label="Zip Code"
          id="company-zip"
          filled
          @input="changed = true"
          required
        ></v-text-field>
        <v-text-field
          v-model="clientData.contact.phone"
          label="Phone"
          id="company-phone"
          @input="changed = true"
          filled
          :rules="phoneRules"
          required
        ></v-text-field>
        <v-text-field
          v-model="clientData.contact.email"
          label="Email"
          id="company-email"
          @input="changed = true"
          filled
          :rules="emailRules"
          required
        ></v-text-field>
        <v-select
          v-model="clientData.style_attrs.primary_color"
          prepend-icon="mdi-circle"
          @input="changed = true"
          :color="clientData.style_attrs.primary_color"
          label="Company Color 1"
          id="company-color-1"
          filled
          :items="colors"
        ></v-select>
        <v-select
          v-model="clientData.style_attrs.secondary_color"
          prepend-icon="mdi-circle"
          label="Company Color 2"
          @input="changed = true"
          id="company-color-2"
          :color="clientData.style_attrs.secondary_color"
          filled
          :items="colors"
        ></v-select>
        <div class="d-flex justify-space-between" v-if="data.logo_url">
          <v-text-field
            readonly
            class="pr-5"
            v-model="data.logo_url"
            @input="changed = true"
            label="Current Logo"
            id="company-logo"
            filled
            required
          ></v-text-field>
          <v-img
            :src="data.logo_url"
            style="max-width:150px; max-height:58px;"
          ></v-img>
        </div>
        <v-file-input
          v-model="logo_url"
          label="Upload a Company Logo"
          id="company-logo-upload"
        ></v-file-input>
        <div class="d-flex justify-space-between" v-if="data.favicon_url">
          <v-text-field
            class="pr-5"
            readonly
            v-model="data.favicon_url"
            @input="changed = true"
            label="Current Favicon"
            id="company-fav"
            filled
            required
          ></v-text-field>
          <v-img
            :src="data.favicon_url"
            class="pr-4"
            style="max-width:58px; max-height:58px;"
          ></v-img>
        </div>
        <v-file-input
          v-model="favicon_url"
          label="Upload a Favicon"
          id="company-upload-fav"
        ></v-file-input>
      </v-form>
      <div class="d-flex justify-center pb-5">
        <v-btn
          v-if="this.newClient"
          large
          color="primary"
          style="width: 90%;"
          :disabled="!isFormValid"
          @click="clickHandler"
          >{{ buttonText }}</v-btn
        >
        <v-btn
          v-if="!this.newClient"
          large
          color="primary"
          :style="textStyle"
          id="company-update-button"
          :disabled="(!isFormValid && !isAdmin) || !changed"
          @click="clickHandler"
          >{{ buttonText }}</v-btn
        >
      </div>
      <div class="d-flex justify-center pb-5">
        <v-btn
          large
          :disabled="!changed"
          style="width: 90%;"
          @click="resetData"
          id="company-update-cancel"
          >Cancel</v-btn
        >
      </div>
      <v-snackbar v-model="snackbar" :timeout="timeout" id="company-snackbar">
        {{ snackbarText }}
        <template v-slot:action="{ attrs }">
          <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { UserPermissions } from '@/mixins';

export default {
  props: ['data', 'newClient'],
  mixins: [UserPermissions],
  data() {
    return {
      clientData: JSON.parse(JSON.stringify(this.data)),
      snackbar: false,
      snackbarText: '',
      timeout: 2000,
      logo_url: [],
      favicon_url: [],
      colors: [
        '#D4002A',
        '#00B2E3',
        '#485683',
        '#000000',
        '#FFFFFF',
        '#828282',
        '#404040',
        '#EF0C35',
        '#E30D0D',
        '#8D0606',
        '#E8A454',
        '#F96A03',
        '#C04805',
        '#F9C303',
        '#EC9718',
        '#4AF65B',
        '#1FAE14',
        '#3BEF1E',
        '#00B2FF',
        '#105FF6',
        '#00256C',
        '#1BADE0',
        '#7D05F4',
        '#4B0097',
        '#87001B',
        '#222222',
        '#2e86ab',
        '#43C59E',
        '#1F1E33',
        '#D4002A',
        '#40C4FF',
        '#3887B7',
      ],
      isFormValid: false,
      emailRules: [(v) => /.+@.+/.test(v) || 'Invalid Email address'],
      phoneRules: [
        (v) => v.toString().length <= 10 || 'Phone number may not exceed 10 digits',
        (v) => v.toString().length > 9 || 'Phone number is not long enough.',
      ],
      changed: false,
    };
  },
  methods: {
    ...mapActions({
      _updateClient: 'account/updateClient',
      _createClient: 'account/createClient',
    }),
    ...mapMutations({
      setClientLogo: 'account/setClientLogo',
    }),
    toBase64(file, type) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        if (type === 'logo') {
          localStorage.setItem('logo_base64', reader.result);
        } else {
          localStorage.setItem('favicon_base64', reader.result);
        }
      };
      reader.onerror = function (error) {
        console.error('Error: ', error);
      };
    },
    getBase64(file, type) {
      this.toBase64(file, type);
    },
    clickHandler() {
      this.changed = false;
      if (!this.newClient) {
        delete this.clientData.groups;
        delete this.clientData.success;
        delete this.clientData.error;
        delete this.clientData.table_name;
        if (localStorage.getItem('logo_base64')) {
          this.clientData.logo_url = localStorage.getItem('logo_base64');
        }
        if (localStorage.getItem('favicon_base64')) {
          this.clientData.favicon_url = localStorage.getItem('favicon_base64');
        }
        this.setClientLogo(this.clientData.logo_url);
        this.data.logo_url = this.clientData.logo_url;
        this.data.favicon_url = this.clientData.favicon_url;
        this.$vuetify.theme.currentTheme.primary = this.clientData.style_attrs.primary_color;
        this.$vuetify.theme.currentTheme.secondary = this.clientData.style_attrs.secondary_color;
        this._updateClient({
          data: this.clientData,
        });
        this.snackbarText = 'Client Updated';
        this.snackbar = true;
      } else {
        delete this.clientData.name;
        delete this.clientData.first_name;
        delete this.clientData.last_name;
        delete this.clientData.address.address1;
        delete this.clientData.address.address2;
        delete this.clientData.logo_src; // The backend is not setup to accept this
        delete this.clientData.favicon_src; // The backend is not setup to accept this
        this._createClient(this.clientData);
        this.snackbarText = 'Client Created';
        this.snackbar = true;
      }
    },
    resetData() {
      this.snackbarText = 'Edits Canceled';
      this.snackbar = true;
      this.changed = false;
      this.clientData = JSON.parse(JSON.stringify(this.data));
    },
  },
  computed: {
    ...mapGetters({
      _getStates: 'account/getStates',
      _isLoggedIn: 'auth/getIsLoggedIn',
    }),
    fullAddress() {
      return `${this.clientData.address} ${this.clientData.address2}`;
    },
    buttonText() {
      if (!this.newClient) {
        return 'Update Profile';
      }
      return 'Create Profile';
    },
    textStyle() {
      if (this.$vuetify.theme.currentTheme.primary !== '#FFFFFF') {
        return 'color: white !important; width:90%;';
      }
      return 'color: black !important; width:90%;';
    },
    infoUpdated() {
      return '';
    },
  },
  watch: {
    logo_url() {
      if (this.logo_url) {
        this.getBase64(this.logo_url, 'logo');
      }
    },
    favicon_url() {
      if (this.favicon_url) {
        this.getBase64(this.favicon_url, 'favicon');
      }
    },
    data: {
      handler() {
        this.clientData = JSON.parse(JSON.stringify(this.data));
        if (!this.clientData.address) {
          this.clientData.address = {
            address_1: '',
            address_2: '',
            state: '',
            country: '',
            zip: '',
          };
        }
        if (!this.clientData.contact) {
          this.clientData.contact = {
            email: '',
            phone: '',
          };
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
